import { Dialog, Transition } from '@headlessui/react';
import React, { useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { toast } from 'react-toastify';
import LoadingIndicator from '../../components/LoadingIndicator';
import { IconClipboardCheck } from '@tabler/icons-react';

export default function ModalProsesTransaksiTertunda({
    isOpenModalRestore,
    closeModalRestore,
    reloadData,
    selectedIds
}) {

    const [loading, setLoading] = useState(false);
    const handleProsesSemuaTransaksiTertunda = async () => {
        setLoading(true)
        const data = { items: selectedIds }
        await http.post(`/transaksi_tertunda/proses`, data, {
            headers: { Authorization: getAuthorizationHeader() },
        }).then((res) => {
            toast.success('Data berhasil diproses', { autoClose: 600, });
            closeModalRestore();
            reloadData();
            // console.log(res.data)
        }).catch((err) => {
            if (err.response?.status === 422) {
                toast.error(err.response.data.message, { autoClose: 600, });
            }
            return err.response?.status
        })
        setLoading(false)
    }

    return (
        <>
            {loading && <LoadingIndicator />}
            <Transition appear show={isOpenModalRestore} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={closeModalRestore}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-2xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 text-left align-middle shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-md p-6">
                                    <div className="text-center">
                                        <div className="mb-4 w-14 h-14 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center mx-auto ring-4 ring-emerald-50 dark:ring-emerald-900/10">
                                            <IconClipboardCheck className="w-7 h-7 text-emerald-600 dark:text-emerald-400" />
                                        </div>
                                        
                                        <Dialog.Title as="h2" className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
                                            Proses Transaksi Penggarus
                                        </Dialog.Title>

                                        <p className="text-slate-500 dark:text-slate-400 text-sm max-w-sm mx-auto mb-6">
                                            Apakah Anda yakin ingin memproses <span className="font-bold text-emerald-600 dark:text-emerald-400">{selectedIds?.length} transaksi</span> yang telah dipilih ini?
                                        </p>

                                        <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                                            <button
                                                type="button"
                                                onClick={closeModalRestore}
                                                className="flex-1 h-12 inline-flex items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors disabled:opacity-50"
                                                disabled={loading}
                                            >
                                                Batal
                                            </button>
                                            <button
                                                type="button"
                                                disabled={loading}
                                                className="flex-1 h-12 inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-600 dark:from-emerald-600 dark:to-emerald-700 text-white font-semibold shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:from-emerald-600 hover:to-emerald-700 transition-all disabled:opacity-70 disabled:cursor-not-allowed"
                                                onClick={handleProsesSemuaTransaksiTertunda}
                                            >
                                                {loading ? 'Memproses ...' : 'Proses Transaksi'}
                                            </button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
